import mixpanel from 'mixpanel-browser';
import { isLocalHost } from '../helpers/environmentHelper';
import { isTrackThrottled } from '../helpers/analyticsThrottle';
import { useCallback } from 'react';

export const useAnalytics = () => {
  const track = useCallback((event: string, props?: Record<string, any>) => {
    if (isLocalHost()) return;

    if (isTrackThrottled()) {
      console.warn(`Analytics track() throttled, event dropped: ${event}`);
      return;
    }

    mixpanel.track(event, props);
  }, []);

  const identify = useCallback((id: string, traits?: Record<string, any>) => {
    if (isLocalHost()) return;

    mixpanel.identify(id);
    if (traits) {
      mixpanel.people.set(traits);
    }
  }, []);

  const alias = useCallback((id: string) => {
    if (isLocalHost()) return;

    mixpanel.alias(id);
  }, []);

  return { track, identify, alias };
};
